import { useEffect, useState } from "react";
import api from "../api";

const MONTHLY = [
  { id: "m5", day: 5, label: "Fatture dello Studio", group: "Studio" },
  { id: "m13", day: 13, label: "Mail avviso clienti (scadenza del 16)", group: "Clienti" },
  { id: "m16", day: 16, label: "Invio F24", group: "F24" },
];
const LAST_DAY = { id: "mlast", label: "Invio F24 (ultimo del mese)", group: "F24" };
const ANNUAL = [
  { id: "tasse-0720", m: 7, d: 20, label: "F24 tasse — saldo + 1° acconto", group: "Tasse" },
  { id: "tasse-0820", m: 8, d: 20, label: "F24 tasse — 2ª rata", group: "Tasse" },
  { id: "tasse-1130", m: 11, d: 30, label: "F24 tasse — 2° acconto", group: "Tasse" },
  { id: "iva-0531", m: 5, d: 31, label: "LIPE e bolli fatture elettroniche", group: "IVA" },
  { id: "iva-0930", m: 9, d: 30, label: "LIPE e bolli fatture elettroniche", group: "IVA" },
  { id: "iva-1130", m: 11, d: 30, label: "LIPE e bolli fatture elettroniche", group: "IVA" },
  { id: "iva-0228", m: 2, d: 28, label: "LIPE e bolli fatture elettroniche", group: "IVA" },
  { id: "dich-0430", m: 4, d: 30, label: "CU lavoratori autonomi e modello IVA", group: "Dichiarazioni" },
  { id: "dich-1031", m: 10, d: 31, label: "770, modello Redditi e IRAP", group: "Dichiarazioni" },
];

const GROUP_COLOR = {
  Studio: "#a78bfa", Clienti: "#38bdf8", F24: "#34d399",
  Tasse: "#f59e0b", IVA: "#f472b6", Dichiarazioni: "#fbbf24", Personali: "#22d3ee", Fiscale: "#fb7185",
};

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const lastDayOfMonth = (y, m) => new Date(y, m + 1, 0).getDate();
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fmtDate = (d) => d.toLocaleDateString("it-IT", { weekday: "short", day: "2-digit", month: "short" });
const daysBetween = (a, b) => Math.round((a - b) / 86400000);
const countdownLabel = (n) => (n === 0 ? "Oggi" : n === 1 ? "Domani" : `tra ${n} giorni`);
const urgencyColor = (n) => (n <= 2 ? "var(--danger)" : n <= 7 ? "#f59e0b" : "#34d399");

function monthlyOccurrences(today, day, count = 18) {
  const out = [];
  for (let k = 0; k < count; k++) {
    const base = new Date(today.getFullYear(), today.getMonth() + k, 1);
    const dim = lastDayOfMonth(base.getFullYear(), base.getMonth());
    const d = new Date(base.getFullYear(), base.getMonth(), Math.min(day, dim));
    if (d >= today) out.push(d);
  }
  return out;
}
function lastDayOccurrences(today, count = 18) {
  const out = [];
  for (let k = 0; k < count; k++) {
    const base = new Date(today.getFullYear(), today.getMonth() + k, 1);
    const d = new Date(base.getFullYear(), base.getMonth(), lastDayOfMonth(base.getFullYear(), base.getMonth()));
    if (d >= today) out.push(d);
  }
  return out;
}
function annualOccurrences(today, m, d, count = 4) {
  const out = [];
  for (let k = 0; k < count; k++) {
    const y = today.getFullYear() + k;
    const dt = new Date(y, m - 1, Math.min(d, lastDayOfMonth(y, m - 1)));
    if (dt >= today) out.push(dt);
  }
  return out;
}

export default function ScadenzePanel() {
  const today = startOfDay(new Date());
  const [doneSet, setDoneSet] = useState(new Set());
  const [doneList, setDoneList] = useState([]);
  const [showDone, setShowDone] = useState(false);
  const [custom, setCustom] = useState([]);
  const [addOpen, setAddOpen] = useState(false);
  const [nLabel, setNLabel] = useState("");
  const [nKind, setNKind] = useState("una_tantum");
  const [nDate, setNDate] = useState("");
  const [nDay, setNDay] = useState("");
  const [nMonth, setNMonth] = useState("");
  const [addMsg, setAddMsg] = useState("");

  const load = () => api.get("/scadenze/done").then((r) => {
    setDoneList(r.data || []);
    setDoneSet(new Set((r.data || []).map((x) => x.key)));
  }).catch(() => {});
  const loadCustom = () => api.get("/scadenze/custom", { noCache: true }).then((r) => setCustom(r.data || [])).catch(() => {});
  const [fiscali, setFiscali] = useState([]);
  const loadFiscali = async () => {
    try {
      const y = new Date().getFullYear();
      const r = await api.get(`/scadenze/fiscali?year=${y}`, { noCache: true });
      let items = r.data.items || [];
      if (new Date().getMonth() === 11) {
        const r2 = await api.get(`/scadenze/fiscali?year=${y + 1}`, { noCache: true });
        items = items.concat(r2.data.items || []);
      }
      setFiscali(items);
    } catch (e) { /* noop */ }
  };
  useEffect(() => { load(); loadCustom(); loadFiscali(); }, []);

  const addCustom = async () => {
    setAddMsg("");
    try {
      await api.post("/scadenze/custom", {
        label: nLabel, kind: nKind,
        date: nKind === "una_tantum" ? nDate : null,
        day: nKind !== "una_tantum" ? parseInt(nDay, 10) || null : null,
        month: nKind === "annuale" ? parseInt(nMonth, 10) || null : null,
      });
      setNLabel(""); setNDate(""); setNDay(""); setNMonth(""); setAddOpen(false);
      loadCustom();
    } catch (e) { setAddMsg(e.response?.data?.detail || e.message); }
  };
  const removeCustom = async (cid) => {
    if (!window.confirm("Eliminare questa scadenza personalizzata (tutte le sue ricorrenze)?")) return;
    await api.delete(`/scadenze/custom/${cid}`);
    loadCustom();
  };

  const markDone = async (item) => {
    setDoneSet((s) => new Set(s).add(item.key));
    try { await api.post("/scadenze/done", { key: item.key, label: item.label, date: iso(item.date) }); } catch (e) { /* noop */ }
    load();
  };
  const undo = async (key) => {
    try { await api.delete(`/scadenze/done?key=${encodeURIComponent(key)}`); } catch (e) { /* noop */ }
    load();
  };

  // per ogni regola, scegli la prima occorrenza NON ancora segnata come fatta
  const pick = (ruleId, occurrences, rule) => {
    for (const d of occurrences) {
      const key = `${ruleId}|${iso(d)}`;
      if (!doneSet.has(key)) return { ...rule, id: ruleId, date: d, key, days: daysBetween(d, today) };
    }
    return null;
  };

  const items = [];
  MONTHLY.forEach((r) => { const it = pick(r.id, monthlyOccurrences(today, r.day), r); if (it) items.push(it); });
  { const it = pick(LAST_DAY.id, lastDayOccurrences(today), LAST_DAY); if (it) items.push(it); }
  ANNUAL.forEach((r) => { const it = pick(r.id, annualOccurrences(today, r.m, r.d), r); if (it) items.push(it); });
  custom.forEach((c) => {
    const rule = { label: c.label, group: "Personali", customId: c.id };
    let occ = [];
    if (c.kind === "una_tantum" && c.date) {
      const [y, m, d] = c.date.split("-").map(Number);
      const dt = new Date(y, m - 1, d);
      if (dt >= today) occ = [dt];
    } else if (c.kind === "mensile") {
      occ = monthlyOccurrences(today, c.day);
    } else if (c.kind === "annuale") {
      occ = annualOccurrences(today, c.month, c.day);
    }
    const it = pick(`custom-${c.id}`, occ, rule);
    if (it) items.push(it);
  });
  // scadenze fiscali dello scadenzario (pagina "Scadenzario fiscale")
  fiscali.forEach((f) => {
    if (f.auto_handled || f.manual_done || doneSet.has(f.key)) return;
    const [y, m, d] = f.date.split("-").map(Number);
    const dt = new Date(y, m - 1, d);
    if (dt < today) return;
    items.push({ label: f.label, group: "Fiscale", id: f.key, date: dt, key: f.key, days: daysBetween(dt, today) });
  });
  items.sort((a, b) => a.days - b.days);
  const within = items.filter((it) => it.days <= 31);

  const recentDone = [...doneList].sort((a, b) => (b.done_at || "").localeCompare(a.done_at || "")).slice(0, 12);

  return (
    <div className="panel" data-testid="scadenze-panel" style={{ marginTop: 8 }}>
      <h3 style={{ marginTop: 0, display: "flex", alignItems: "center" }}>📌 Prossime scadenze <span className="muted" style={{ fontSize: 13, fontWeight: 400, marginLeft: 6 }}>(entro 1 mese)</span>
        <button className="btn sm" style={{ marginLeft: "auto" }} onClick={() => setAddOpen((v) => !v)} data-testid="scadenza-add-toggle">{addOpen ? "✕ Chiudi" : "+ Aggiungi scadenza"}</button>
      </h3>
      {addOpen && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center", marginBottom: 10, padding: 10, border: "1px solid var(--border)", borderRadius: 10 }} data-testid="scadenza-add-form">
          <input style={{ flex: 2, minWidth: 180 }} placeholder="Descrizione (es. Rata rottamazione)" value={nLabel} onChange={(e) => setNLabel(e.target.value)} data-testid="scadenza-add-label" />
          <select value={nKind} onChange={(e) => setNKind(e.target.value)} data-testid="scadenza-add-kind">
            <option value="una_tantum">Una tantum</option>
            <option value="mensile">Ogni mese</option>
            <option value="annuale">Ogni anno</option>
          </select>
          {nKind === "una_tantum" && <input type="date" value={nDate} onChange={(e) => setNDate(e.target.value)} data-testid="scadenza-add-date" />}
          {nKind !== "una_tantum" && <input type="number" min={1} max={31} style={{ width: 90 }} placeholder="Giorno" value={nDay} onChange={(e) => setNDay(e.target.value)} data-testid="scadenza-add-day" />}
          {nKind === "annuale" && (
            <select value={nMonth} onChange={(e) => setNMonth(e.target.value)} data-testid="scadenza-add-month">
              <option value="">Mese…</option>
              {["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"].map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
          )}
          <button className="btn sm primary" onClick={addCustom} data-testid="scadenza-add-save">Salva</button>
          {addMsg && <span style={{ color: "#f87171", fontSize: 12 }}>{addMsg}</span>}
        </div>
      )}
      <p className="muted" style={{ marginTop: 0, fontSize: 13 }}>Spunta una scadenza come fatta: sparisce e al suo posto comparirà la prossima.</p>
      {within.length === 0 ? (
        <p className="muted" data-testid="scadenze-empty">Nessuna scadenza nei prossimi 31 giorni. 🎉</p>
      ) : (
        <div style={{ maxHeight: 360, overflowY: "auto" }}>
          <table className="inbox-table" style={{ marginTop: 4 }}>
            <tbody>
              {within.map((it) => (
                <tr key={it.key} data-testid={`scadenza-row-${it.id}`}>
                  <td style={{ width: 26, textAlign: "center" }}>
                    <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: GROUP_COLOR[it.group] || "#94a3b8" }} />
                  </td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{it.label}</div>
                    <div className="muted" style={{ fontSize: 12 }}>
                      <span className="pill" style={{ fontSize: 10.5, marginRight: 6, background: "rgba(148,163,184,.12)", border: "1px solid var(--border)" }}>{it.group}</span>
                      {fmtDate(it.date)}
                    </div>
                  </td>
                  <td style={{ width: 120, textAlign: "right" }}>
                    <span className="pill" data-testid={`scadenza-countdown-${it.id}`}
                      style={{ fontSize: 11.5, fontWeight: 700, whiteSpace: "nowrap", color: urgencyColor(it.days),
                        background: "transparent", border: `1px solid ${urgencyColor(it.days)}55` }}>
                      {countdownLabel(it.days)}
                    </span>
                  </td>
                  <td style={{ width: 84, textAlign: "right", whiteSpace: "nowrap" }}>
                    <button className="btn sm" onClick={() => markDone(it)} data-testid={`scadenza-done-${it.id}`} title="Segna come fatta">✓ Fatta</button>
                    {it.customId && <button className="btn sm" style={{ marginLeft: 4 }} onClick={() => removeCustom(it.customId)} data-testid={`scadenza-del-${it.customId}`} title="Elimina scadenza personalizzata">🗑</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {recentDone.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <button className="btn sm" onClick={() => setShowDone((v) => !v)} data-testid="scadenze-toggle-done">
            {showDone ? "▾" : "▸"} Fatte di recente ({recentDone.length})
          </button>
          {showDone && (
            <ul className="today-list" style={{ marginTop: 6 }} data-testid="scadenze-done-list">
              {recentDone.map((d) => (
                <li key={d.key} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ textDecoration: "line-through", color: "var(--muted)" }}>{d.label || d.key}</span>
                  {d.date && <span className="muted" style={{ fontSize: 12 }}>· {d.date.split("-").reverse().join("/")}</span>}
                  <button className="btn sm" style={{ marginLeft: "auto" }} onClick={() => undo(d.key)} data-testid={`scadenza-undo-${d.key}`}>↩︎ Annulla</button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
